export default class User {
  FirstName = '';
  LastName = '';
  Email?: string;
  PhoneNumber = '';
  FacebookId?: string;
  AppleId?: string;
  CreationType?: string;
  Id?: string;
}
